<template>
    <v-button v-if="!error" label="Google" ico="ion-social-googleplus" icoPosition="left" classe="button-dark btn-dark btn-google btn-block mb-3" @click="login"></v-button>
</template>

<script>
    export default {
        data() {
            return {
                error: false,
                apiGoogle: null,
            }
        },
        methods: {
            login() {
                this.$root.setLoading('Carregando perfil do Google', true)
                this.apiGoogle.auth2.getAuthInstance().signIn().then((success) => {
                    let data = {
                        name: '',
                        id: success.ya,
                        type: 2,
                    }
                    this.$emit('login', data)
                }, (error) => {
                    console.dir(error)
                    this.$root.setLoading()
                })
            },
            logout() {
                this.apiGoogle.auth2.getAuthInstance().signOut()
            }
        },
        created() {
            require('google-client-api')().then( ( gapi ) => {
                this.apiGoogle = gapi
                this.apiGoogle.load('client:auth2', {
                    callback: () => {
                        this.apiGoogle.client.init({
                            apiKey: process.env.GOOGLE_API_KEY,
                            clientId: process.env.GOOGLE_CLIENT_ID,
                            scope: 'https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/plus.me',
                        }).then((success) => {
                            console.dir('success')
                        }, (error) => {
                            this.error = true
                            console.warn('error')
                            console.dir(error)
                        })
                    },
                    onerror: () => {
                        this.error = true
                        console.warn('error')
                    }
                })
            })
        }
    }
</script>

<style>
    .btn-google i{
        font-size: 1.3em;
    }
</style>


// WEBPACK FOOTER //
// src/components/SocialButtons/GoogleLogin.vue